import React, { useEffect, useMemo, useState } from "react";
import { useManualUpdate, useSupplier, wareHouseTransit } from "./store";
import CardDiv from "modules/common/card-div/CardDiv";
import { Select } from "antd";
import { useProductMapping } from "modules/dashboards/actionables/store";
import OutwardTransitTable from "./OutwardTransitTable";
import { calculateSkus, filterAndMapWarehouses } from "modules/utilities/utility";
import { comboProductMappings, requiredWarehouses } from "../../config";

function OutwardIntransit() {
  const { transitData, transitLoading, fetchTransitData } = wareHouseTransit();
  const { productsData, isLoading, fetchProducts } = useProductMapping();
  const { wareHousesData, fetchWareHouses } = useManualUpdate();
  const [selectedToWarehouse, setSelectedToWarehouse] = useState("");
  const [selectedFromWarehouse, setSelectedFromWarehouse] = useState("");
  const [selectedSku, setSelectedSku] = useState("");
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
      fetchProducts();
      fetchWareHouses();
  }, []);

  useEffect(() => {
      fetchTransitData(selectedFromWarehouse, selectedToWarehouse, selectedSku);
  }, [selectedFromWarehouse, selectedToWarehouse, selectedSku]);

  useEffect(() => {
    setSortedData(transitData);
  }, [transitData]);

  const skus = useMemo(
    () => calculateSkus(productsData, comboProductMappings),
    [productsData]
  );

  const warehouses = useMemo(
    () => filterAndMapWarehouses(wareHousesData, requiredWarehouses),
    [wareHousesData]
  );


  const handleWarehouseFilterChange = (value) => {
    setSelectedToWarehouse(value);
  };

  const handleWarehouseFromFilterChange = (value) => {
    setSelectedFromWarehouse(value);
  };
  const handleSkuFilterChange = (value) => {
    setSelectedSku(value);
  };

  return (
    <div>
      <div>
        <CardDiv
          title={
            <div className="">
              <div className="fs-2">Outwards Transit</div>
            </div>
          }
          component={
            <div>
              <div className="d-flex gap-5">
                <Select
                  style={{ width: "30%" }}
                  placeholder="From Warehouse"
                  options={warehouses}
                  allowClear
                  onChange={handleWarehouseFromFilterChange}
                />
                <Select
                  style={{ width: "30%" }}
                  placeholder="To Warehouse"
                  options={warehouses}
                  allowClear
                  onChange={handleWarehouseFilterChange}
                />
                <Select
                  style={{ width: "30%" }}
                  placeholder="Select Skus"
                  options={skus}
                  allowClear
                  onChange={handleSkuFilterChange}
                />
              </div>
              <div>
                <OutwardTransitTable
                  isLoading={transitLoading}
                  warehouses={warehouses}
                  transitData={sortedData}
                />
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default OutwardIntransit;
